// extracted by mini-css-extract-plugin
module.exports = {"footerBox":"_2bSkW","alertBox":"_67vZ9","fixedFooter":"_1IDGP"};